
export const isSuperSmall = (val) => !val || Math.abs(val) < 0.01;